import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, message, Modal } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';

const CPedidos = () => {
    const [pedidos, setPedidos] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detallesSeleccionados, setDetallesSeleccionados] = useState([]);
    const { user } = useContext(LoginContext);

    useEffect(() => {
        fetchPedidos();
    }, []);

    const fetchPedidos = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${user.token}`,
            };
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/pedido`, { headers });
            setPedidos(response.data);
        } catch (error) {
            message.error('Error al obtener los pedidos');
        }
    };

    const handleVerDetalles = (items) => {
        setDetallesSeleccionados(items);
        setIsModalVisible(true);
    };

    const handleEstadoChange = async (idPedido, estado) => {
        try {
            const headers = {
                Authorization: `Bearer ${user.token}`,
            };
            await axios.patch(`${process.env.REACT_APP_API_URL}/pedido/${idPedido}`, { estado }, { headers });
            message.success(`Pedido marcado como ${estado}`);
            fetchPedidos(); // Actualizamos la lista de pedidos
        } catch (error) {
            message.error(`Error al actualizar el estado del pedido`);
        }
    };

    const confirmEstadoChange = (idPedido, estado) => {
        Modal.confirm({
            title: 'Confirmar Cambio de Estado',
            content: `¿Estás seguro de que deseas cambiar el estado del pedido a "${estado}"?`,
            okText: 'Sí',
            cancelText: 'No',
            onOk: () => handleEstadoChange(idPedido, estado),
        });
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
    };

    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (fecha) => new Date(fecha).toLocaleString(),
        },
        {
            title: 'Estado',
            dataIndex: 'estado',
            key: 'estado',
        },
        {
            title: 'Cliente',
            dataIndex: ['idCliente', 'razonSocial'],
            key: 'cliente',
        },
        {
            title: 'Acciones',
            key: 'acciones',
            render: (text, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        type="primary"
                        onClick={() => handleVerDetalles(record.items)}
                    >
                        Ver Detalles
                    </Button>
                    <Button
                        type="default"
                        style={{ backgroundColor: 'green', color: 'white' }}
                        onClick={() => confirmEstadoChange(record._id, 'Aprobado')}
                    >
                        Aprobado
                    </Button>
                    <Button
                        type="default"
                        style={{ backgroundColor: 'red', color: 'white' }}
                        onClick={() => confirmEstadoChange(record._id, 'Rechazado')}
                    >
                        Rechazado
                    </Button>
                </div>
            ),
        },
    ];

    return (
        <div>
            <h2>Pedidos</h2>
            <Table
                columns={columns}
                dataSource={pedidos}
                rowKey="_id"
                pagination={{ pageSize: 10 }}
            />

            {/* Modal para ver los detalles de los pedidos */}
            <Modal
                title="Detalles del Pedido"
                visible={isModalVisible}
                onCancel={handleModalClose}
                footer={[
                    <Button key="close" onClick={handleModalClose}>
                        Cerrar
                    </Button>,
                ]}
                width={800}
            >
                <Table
                    dataSource={detallesSeleccionados}
                    rowKey="_id"
                    pagination={false}
                    columns={[
                        {
                            title: 'Nombre del Artículo',
                            dataIndex: ['articulo', 'nombre'],
                            key: 'nombre',
                        },
                        {
                            title: 'Marca',
                            dataIndex: ['articulo', 'idmarca', 'nombre'],
                            key: 'marca',
                        },
                        {
                            title: 'Categoría',
                            dataIndex: ['articulo', 'idcategoria', 'nombre'],
                            key: 'categoria',
                        },
                        {
                            title: 'Cantidad',
                            dataIndex: 'cantidad',
                            key: 'cantidad',
                        },
                    ]}
                />
            </Modal>
        </div>
    );
};

export default CPedidos;